import { ApiClientService, EntityApiService } from '@dofleini/security';
import { authentication } from '@/settings';

class DashboardApiService extends EntityApiService {
  
  getUsersQuantity = function(filters) {
    return ApiClientService.post(this.getPath('/users/reports/users-quantity'), filters).then((response) => response?.data);
  };
  
  getPaymentData = function(filters) {
    return ApiClientService.post(this.getPath('/payment-request/payment-data'), filters).then((response) => response?.data);
  };
  
  getPaymentHistogram = function(filters) {
    return ApiClientService.post(this.getPath('/payment-request/payment-histogram'), filters).then((response) => response?.data);
  };
  
  getPaymentByStatus = function(filters) {
    return ApiClientService.post(this.getPath('/payment-request/payment-by-status'), filters).then((response) => response?.data);
  };
}

export default new DashboardApiService(`${authentication.path}/api`);
